const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class UGCCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.8,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.8,
              spacing: 5,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 4.2,
              spacing: 5,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 6.2,
              spacing: 5,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('ugc-carousel')) {
  customElements.define('ugc-carousel', UGCCarousel)
}
